module.exports = __webpack_public_path__ + "static/img/0542_8.a914580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_8.jpg
// module id = 932h
// module chunks = 1